module.exports = __webpack_public_path__ + "img/antes_despues_143.c883d4a3.png";